import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MyListingsApi {
  prospektrBackendBaseURL = environment.prospektrBackendBaseURL;
  createListingApi = 'createListing';
  getMyListingsApi = 'getListings';

  constructor(private http: HttpClient) { }

  createListing(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .post(`${this.prospektrBackendBaseURL}${this.createListingApi}`, params)
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  getMyListings(params): Observable<any> {
    return new Observable((observer) => {
      this.http
        .get(`${this.prospektrBackendBaseURL}${this.getMyListingsApi}`, { params })
        .pipe(
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe(
          (res) => {
            observer.next(res);
          },
          (err) => {
            observer.next({});
          }
        );
    });
  }

  getListingById(id: string): Observable<any> {
    return new Observable((observer) => {
      this.http.get(`${this.prospektrBackendBaseURL}getListingById/${id}`).pipe(
        finalize(() => {
          observer.complete();
        })
      ).subscribe(
        (res) => {
          observer.next(res);
        },
        (err) => {
          observer.next({});
        }
      );
    });
  }

  updateListing(params): Observable<any> {
    return new Observable((observer) => {
      this.http.post(`${this.prospektrBackendBaseURL}updateListing`, params).pipe(
        finalize(() => {
          observer.complete();
        })
      ).subscribe(
        (res) => {
          observer.next(res);
        },
        (err) => {
          observer.next({});
        }
      );
    });
  }

  deleteListing(params): Observable<any> {
    return new Observable((observer) => {
      this.http.post(`${this.prospektrBackendBaseURL}deleteListing`, params).pipe(
        finalize(() => {
          observer.complete();
        })
      ).subscribe(
        (res) => {
          observer.next(res);
        },
        (err) => {
          observer.next({});
        }
      );
    });
  }

}